export const FREE_SHOW_MORE_UPGRADE_SHOWED = 'FREE_SHOW_MORE_UPGRADE_SHOWED'
export const DRUG_LIMIT = 5000
